import { DataList } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export const DrawerItem = ({ title, children }: { title: string | ReactNode; children: ReactNode }) => {
  return (
    <DataList.Item pt="4">
      <DataList.ItemLabel>{title}</DataList.ItemLabel>
      <DataList.ItemValue>{children}</DataList.ItemValue>
    </DataList.Item>
  );
};
